/**
 * Scroll até o id da seção, compensando a topbar fixa (#menu).
 */
export function scrollToSectionId(id) {
  if (!id) return;
  const el = document.getElementById(id);
  if (!el) return;

  const header = document.getElementById("menu");
  const offset = (header ? header.offsetHeight : 0) + 10;
  const top =
    el.getBoundingClientRect().top + window.pageYOffset - offset;

  window.scrollTo({
    top: Math.max(0, top),
    behavior: "smooth",
  });
}
